import React from "react";
import { Link } from "react-router-dom";
import { ImageIcon } from "lucide-react";
import { fileUrl, formatNok } from "../../lib/api";
import { AVAIL_STYLE } from "./ShopLayout";

export default function ProductCard({ p }) {
  const cover = p.images?.[0];
  return (
    <Link
      to={`/butikk/${p.slug}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-hairline bg-white shadow-sm transition-all hover:-translate-y-0.5 hover:border-electric hover:shadow-md"
      data-testid={`product-card-${p.slug}`}
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-slate-100">
        {cover ? (
          <img src={fileUrl(cover)} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-ink/30"><ImageIcon className="h-10 w-10" /></div>
        )}
        <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-semibold ${AVAIL_STYLE[p.availability] || "bg-slate-100"}`} data-testid="product-card-availability">
          {p.availability}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <p className="text-xs font-medium uppercase tracking-wider text-ink/50">{p.category}</p>
        <h3 className="mt-1 font-heading text-base font-bold text-navy leading-snug line-clamp-2" data-testid="product-card-name">{p.name}</h3>
        {p.condition && <p className="mt-1 text-sm text-ink/60">Tilstand: {p.condition}</p>}
        <p className="mt-auto pt-3 font-heading text-lg font-bold text-electric" data-testid="product-card-price">{formatNok(p.price)}</p>
      </div>
    </Link>
  );
}
